import React from 'react';
import InfoTable from '../../../../components/table/InfoTable';
import SendMessageService from '../../../../containers/app/common/SendMessageService';
import { setDash, setPhoneFormat } from '../../../../lib/common';
import OpenReturnExchangeAttachment from '../../../../containers/app/common/OpenReturnExchangeAttachment';
import { setDateFormat } from '../../../../lib/moment';
import {
  DELIVERY_DETAIL_STATUS_TEXT,
  ORDER_ACCEPT_MANAGER_TEXT,
  ORDER_DELIVERY_TYPE_TEXT,
  ORDER_EXCHANGE_STATUS_TEXT,
  ORDER_EXCHANGE_TYPE_TEXT,
  ORDER_PROCESS_HISTORY_TYPE_TEXT,
  ORDER_PROCESS_MANAGER_TEXT,
  RETURN_EXCHANGE_REASON_TYPE,
} from '../../../../constants/service/app/orderConstants';
import { AMONDZ_MEMBER_TYPE, DATE_FORMAT } from '../../../../constants/service/common/utilConstants';
import OpenOrderDeliveryTracking from '../../../../containers/app/common/OpenOrderDeliveryTracking';

const OrderExchangeHistory = (props) => {
  const { exchangeHistory } = props;

  if (!exchangeHistory?.orderExchangeHistory.length) return null;
  return (
    <div className="order-detail-content">
      {/* 교환 정보 */}
      <div className="order-detail-section">
        <div className="title">교환 정보</div>

        <InfoTable>
          <tbody>
            <tr>
              <td className="label tc">교환 처리 상태</td>
              <td className="tc">{ORDER_EXCHANGE_STATUS_TEXT[exchangeHistory.orderExchangeStatus]}</td>
              <td className="label tc">교환 사유</td>
              <td className="tc">
                {
                  <OpenReturnExchangeAttachment
                    title="교환사유"
                    orderReturnExchangeId={exchangeHistory.orderExchangeId}
                    type={RETURN_EXCHANGE_REASON_TYPE.EXCHANGE_REQUEST}
                    text={ORDER_EXCHANGE_TYPE_TEXT[exchangeHistory.exchangeType]}
                    reason={exchangeHistory.changeReason}
                  />
                }
              </td>
            </tr>
            <tr>
              <td className="label tc">접수자</td>
              <td className="tc">{setDash(ORDER_ACCEPT_MANAGER_TEXT[exchangeHistory.acceptManager])}</td>
              <td className="label tc">교환처리자</td>
              <td className="tc">{setDash(ORDER_PROCESS_MANAGER_TEXT[exchangeHistory.changeManager])}</td>
            </tr>
            <tr>
              <td className="label tc">교환 사유 수정 일시</td>
              <td className="tc" colSpan={3}>
                {setDateFormat(exchangeHistory.exchangeReasonModifyDate, DATE_FORMAT.YMD_HM_DASH_FORMAT)}
              </td>
            </tr>
            <tr>
              <td className="label tc"> 교환 거부 사유</td>
              <td className="tc">
                {
                  <OpenReturnExchangeAttachment
                    title="교환 거부사유"
                    orderReturnExchangeId={exchangeHistory.orderExchangeId}
                    type={RETURN_EXCHANGE_REASON_TYPE.EXCHANGE_REJECT}
                    text="사유 보기"
                    reason={exchangeHistory.rejectReason}
                  />
                }
              </td>
              <td className="label tc">교환 거부 일시</td>
              <td className="tc">{setDateFormat(exchangeHistory.rejectDate, DATE_FORMAT.YMD_HM_DASH_FORMAT)}</td>
            </tr>
          </tbody>
        </InfoTable>
      </div>

      {/* 교환품 배송 정보 */}
      <div className="order-detail-section">
        <div className="title">교환품 배송 정보</div>

        <InfoTable>
          <tbody>
            <tr>
              <td className="label tc">교환 배송 방법</td>
              <td className="tc">{setDash(ORDER_DELIVERY_TYPE_TEXT[exchangeHistory.deliveryType])}</td>
              <td className="label tc">교환품 배송 상세 상태</td>
              <td className="tc">{setDash(DELIVERY_DETAIL_STATUS_TEXT[exchangeHistory.deliveryStatus])}</td>
            </tr>
            <tr>
              <td className="label tc">교환 배송 택배사</td>
              <td className="tc">{setDash(exchangeHistory.deliveryEnterprise)}</td>
              <td className="label tc">교환 배송 송장 번호</td>
              <td className="tc">
                <OpenOrderDeliveryTracking
                  text={exchangeHistory.invoiceNumber}
                  deliveryId={exchangeHistory.deliveryId}
                />
              </td>
            </tr>
          </tbody>
        </InfoTable>
      </div>

      {/* 교환품 배송지 정보 */}
      <div className="order-detail-section">
        <div className="title">교환품 배송지 정보</div>

        <InfoTable>
          <tbody>
            <tr>
              <td className="label tc">수취인명</td>
              <td className="tc">{exchangeHistory.recipientName}</td>
              <td className="label tc">수취인 연락처</td>
              <td className="tc">
                <SendMessageService
                  text={setPhoneFormat(exchangeHistory.exchangeRecipientPhone)}
                  memberType={AMONDZ_MEMBER_TYPE.RECIPIENT}
                  targetId={exchangeHistory.orderItemId}
                />
              </td>
            </tr>
            <tr>
              <td className="label tc">배송지</td>
              <td className="tc" colSpan={3}>
                ({setDash(exchangeHistory.postCode)})
                <br />
                {setDash(exchangeHistory.address)}
              </td>
            </tr>
            <tr>
              <td className="label tc">배송 메모</td>
              <td className="tc" colSpan={3}>
                {setDash(exchangeHistory.message)}
              </td>
            </tr>
          </tbody>
        </InfoTable>
      </div>

      {/* 교환 처리 이력 */}
      <div className="order-detail-section">
        <div className="title">교환 처리 이력</div>

        <div className="order-exchange-history-table">
          <InfoTable className="order-exchange-history" scroll={{ x: true }}>
            <thead>
              <tr>
                <th>상태</th>
                <th>처리일시</th>
                <th>사유</th>
              </tr>
            </thead>

            <tbody>
              {exchangeHistory.orderExchangeHistory.map((item, index) => {
                return (
                  <tr key={index}>
                    <td className="label tc">{ORDER_PROCESS_HISTORY_TYPE_TEXT[item.status]}</td>
                    <td className="tc">{setDateFormat(item.value, DATE_FORMAT.FULL_DASH_FORMAT)}</td>
                    <td className="tc">
                      {
                        <OpenReturnExchangeAttachment
                          title={item.type ? '교환사유' : '교환 거부사유'}
                          orderReturnExchangeId={item.orderExchangeId}
                          type={
                            item.type
                              ? RETURN_EXCHANGE_REASON_TYPE.EXCHANGE_REQUEST
                              : RETURN_EXCHANGE_REASON_TYPE.EXCHANGE_REJECT
                          }
                          text={item.type ? item.type : '사유 보기'}
                          reason={item.reason}
                        />
                      }
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </InfoTable>
        </div>
      </div>
    </div>
  );
};

export default OrderExchangeHistory;
